import { Outlet } from 'react-router-dom';
import { useAuth } from '@/auth/AuthContext';
import { ForcedPasswordModal } from '@/components/ForcedPasswordModal';

/**
 * كلمة سر ضبطها غيرك: تُغيَّر قبل أي شيء آخر.
 *
 * العلم يأتي من `/auth/me` في كل تحميل، لا من رد الدخول — فتحديث الصفحة
 * لا يتخطّاه، وهو أول ما يفعله من لا يريد تغيير كلمة سرّه.
 *
 * #64: كان الحارس يحوّل إلى `/account?mustChangePassword=1` حيث الحقل في
 * أسفل الصفحة. الآن الصفحة التي هبط عليها تُعرض تحت نافذة مقفلة فيها
 * الحقول الثلاثة، فلا تحويل ولا بحث. الصفحة خلفها لا تُلمس حتى ينتهي.
 */
export function RequirePasswordChange({ children }: { children?: React.ReactNode }) {
  const { mustChangePassword } = useAuth();

  return (
    <>
      {children ?? <Outlet />}
      {mustChangePassword && <ForcedPasswordModal />}
    </>
  );
}
